import { render, staticRenderFns } from "./PosPT_Total.vue?vue&type=template&id=ddc751b8"
import script from "./PosPT_Total.vue?vue&type=script&lang=js"
export * from "./PosPT_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports